module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/35b29c7b863985e291b49d355cea293e.png";